import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import toast from 'react-hot-toast';
import { retrospectivaAPI } from '../../services/inovacaoAPI';

export default function RetrospectivaDepoimento() {
  const { token } = useParams();
  const [texto, setTexto] = useState('');
  const [enviado, setEnviado] = useState(false);

  async function enviar() {
    if (!texto.trim()) { toast.error('Escreva algo'); return; }
    try {
      await retrospectivaAPI.depoimentoPublico(token, texto);
      toast.success('Depoimento registrado, obrigado!');
      setEnviado(true);
    } catch (e) {
      toast.error(e.response?.data?.detail?.message || 'Erro');
    }
  }

  if (enviado) {
    return (
      <div style={{ padding: 40, maxWidth: 600, margin: '0 auto', textAlign: 'center' }}>
        <h1 style={{ color: '#27ae60' }}>Obrigado!</h1>
        <p>Seu depoimento foi registrado. Pode compor o próximo release do GNI.</p>
      </div>
    );
  }

  return (
    <div style={{ padding: 32, maxWidth: 700, margin: '0 auto' }}>
      <h1 style={{ color: 'var(--brand, #20a490)' }}>Deixar depoimento</h1>
      <p>Como esse projeto mudou sua rotina? Quanto tempo ganhou? Vale a pena contar.</p>
      <textarea value={texto} onChange={(e) => setTexto(e.target.value)}
                style={{ width: '100%', padding: 14, minHeight: 180, borderRadius: 6,
                         border: '1px solid #ccc', fontSize: '1rem' }}
                placeholder="Ex: Antes gastava 8h/dia conferindo guias manualmente..." />
      <button onClick={enviar}
              style={{ background: 'var(--brand, #20a490)', color: 'var(--brand-ink, #fff)', padding: '12px 32px',
                       border: 'none', borderRadius: 6, marginTop: 16, cursor: 'pointer' }}>
        Enviar depoimento
      </button>
    </div>
  );
}
